module.exports = __webpack_public_path__ + "static/media/fire8.e20b10c4.svg";